'use client'

import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip"

interface FeatureTooltipProps {
  children: React.ReactNode;
}

export default function FeatureTooltip({ children }: FeatureTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger onClick={(e) => e.preventDefault()}>
          <svg
            width="19"
            height="18"
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.08594 15.75C5.35791 15.75 2.33594 12.728 2.33594 9C2.33594 5.27198 5.35791 2.25 9.08594 2.25C12.814 2.25 15.8359 5.27198 15.8359 9C15.8359 12.728 12.814 15.75 9.08594 15.75ZM9.08594 14.4C10.5181 14.4 11.8916 13.8311 12.9043 12.8184C13.917 11.8057 14.4859 10.4322 14.4859 9C14.4859 7.56783 13.917 6.19432 12.9043 5.18162C11.8916 4.16893 10.5181 3.6 9.08594 3.6C7.65377 3.6 6.28026 4.16893 5.26756 5.18162C4.25486 6.19432 3.68594 7.56783 3.68594 9C3.68594 10.4322 4.25486 11.8057 5.26756 12.8184C6.28026 13.8311 7.65377 14.4 9.08594 14.4ZM8.41094 5.625H9.76094V6.975H8.41094V5.625ZM8.41094 8.325H9.76094V12.375H8.41094V8.325Z"
              fill="#9E9E9E"
            />
          </svg>
        </TooltipTrigger>
        <TooltipContent className="bg-white px-2 py-1 max-w-[200px] text-center">
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
